import { Button, notification } from "antd";
import { useState, useContext, useEffect } from "react";
import { encrypt } from "utils/utils";
import Countdown from "./countdown";
import ModalSendLink from "./modal-send-link";
import ModalAlert from "components/modal-alert";
import Context from "context/appContext";
import Loading from "components/loading";
import { ApiError, FeedbackError } from "constants/errors";

// @styles
import "./styles.scss";

const Status = {
  PENDING: "PENDIENTE",
  FAILED: "FALLIDO",
  VALIDATED: "VALIDADO",
  FINISHED: "FINALIZADO",
  CANCELLED: "CANCELADO",
};

export default function VehicleInspection({ numSequence, setVehicleInspectionReady, setIsValidSerialNumber, isRecovering, setIsRecovering, attemptCounter, setAttemptCounter }) {
  const {
    setReturnButton,
    customRequest,
    folio,
    dataForm: { data, formResponses },
    formStatus: { currentStep },
  } = useContext(Context);

  const { formDefinition } = data ?? {};
  const { components } = formDefinition ?? {};
  const step = components && components[currentStep];
  const { components: fields } = step ?? {};
  const info = fields?.find((e) => e.key == "info")?.content;
  const steps = fields?.find((e) => e.key == "steps")?.properties?.arraySteps;
  const arraySteps = JSON.parse(steps)?.steps;
  const [modalSendLink, setModalSendLink] = useState({});
  const [api, contextHolder] = notification.useNotification();
  const [counting, setCounting] = useState(false);
  const [sendingLink, setSendingLink] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [checkingVin, setCheckingVin] = useState(true);
  const [done, setDone] = useState(false);
  const [modalAlert, setModalAlert] = useState({});
  const contactPhone = formResponses.find((e) => e.key == "telefono")?.value;
  const contactEmail = formResponses.find((e) => e.key == "email").value;
  const dataPreloaded = { contactPhone, contactEmail };

  const getNotificationStyle = (type) => {
    return {
      success: {
        color: "#707070",
        backgroundColor: "#FFF",
        borderTopRightRadius: "14px",
        borderTopLeftRadius: "14px",
        borderBottomLeftRadius: "14px",
        borderBottomRightRadius: "14px",
        fontFamily: "Arial",
        fontSize: "14px",
      },
      error: {
        color: "#707070",
        backgroundColor: "#FFF",
        borderTopRightRadius: "14px",
        borderTopLeftRadius: "14px",
        borderBottomLeftRadius: "14px",
        borderBottomRightRadius: "14px",
        fontFamily: "Arial",
        fontSize: "14px",
      },
    }[type];
  };

  const openNotification = (type) => {
    api[type]({
      message: ``,
      description: "Liga enviada",
      style: getNotificationStyle(type),
    });
  };

  const sendLink = async (mode, field) => {
    setSendingLink(true);
    setModalSendLink({ visible: false });

    const originUrl = `${window.location.origin}/${window.location.pathname.replaceAll("/", "")}/${generateToken()}`;
    const notificationChannel = mode.toUpperCase();

    const body = {
      folio,
      originUrl,
      notificationChannel,
      ...(notificationChannel === "SMS" && { phoneNumber: field.replaceAll(" ", "") }),
      ...(notificationChannel === "EMAIL" && { email: field }),
    };

    const url = `${process.env.REACT_APP_PATH}virtual-inspection`;
    const headers = { "Content-Type": "application/json" };
    const method = "POST";
    const resp = await customRequest(url, headers, method, body);
    setSendingLink(false);
    const { respuesta, renderMessage } = resp ?? {};
    const { status } = respuesta ?? {};

    if (resp.toString().includes(ApiError.failedFetch)) {
      setModalAlert({
        icon: "fa-circle-xmark",
        iconColor: "#d12d35",
        title: FeedbackError.failedFetch.title,
        description: FeedbackError.failedFetch.desc,
        buttonText: "Aceptar",
        visible: true,
        onConfirm: () => {
          setModalAlert({ visible: false });
        },
      });
      return;
    }

    if (status === Status.PENDING) {
      openNotification("success");
      setCounting(true);
    } else {
      const { title, body } = renderMessage;
      let info = {
        icon: "fas fa-exclamation-triangle",
        iconColor: "#ED8B00",
        title,
        description: body,
        buttonText: "Aceptar",
        visible: true,
        onConfirm: () => {
          setModalAlert({ visible: false });
          if (status === Status.FAILED) goBack();
          if (status === Status.CANCELLED) window.location.reload();
        },
      };
      setModalAlert(info);
    }
  };

  const verifyPhotos = async () => {
    setVerifying(true);
    const url = `${process.env.REACT_APP_PATH}virtual-inspection-status/get`;
    const headers = { "Content-Type": "application/json" };
    const method = "POST";
    const resp = await customRequest(url, headers, method, { folio });
    setVerifying(false);
    const { respuesta, renderMessage } = resp ?? {};
    const { status } = respuesta ?? {};

    if (resp.toString().includes(ApiError.failedFetch)) {
      setModalAlert({
        icon: "fa-circle-xmark",
        iconColor: "#d12d35",
        title: FeedbackError.failedFetch.title,
        description: FeedbackError.failedFetch.desc,
        buttonText: "Aceptar",
        visible: true,
        onConfirm: () => {
          setModalAlert({ visible: false });
        },
      });
      return;
    }

    if (status === Status.FINISHED) {
      setDone(true);
      setVehicleInspectionReady(true);
    } else {
      const { title, body } = renderMessage;
      let info = {
        icon: "fas fa-exclamation-triangle",
        iconColor: "#ED8B00",
        title,
        description: body,
        buttonText: "Aceptar",
        visible: true,
        onConfirm: () => {
          setModalAlert({ visible: false });
          if (status === Status.FAILED) goBack();
          if (status === Status.CANCELLED) window.location.reload();
        },
      };
      setModalAlert(info);
    }
  };

  const getToken = () => {
    const serviceOptions = JSON.parse(process.env.REACT_APP_FIND_RESPONSES_SERVICE);
    return encrypt(JSON.stringify(numSequence), serviceOptions.key);
  };

  const goBack = () => {
    setIsValidSerialNumber(false);
    const e = document.querySelector("#goToBack");
    e.click();
  };

  const setVin = async() => {
    const url = `${process.env.REACT_APP_PATH}virtual-inspection-attempt`;
    const headers = { "Content-Type": "application/json" };
    const method = "POST";
    const resp = await customRequest(url, headers, method, { folio });
    const { respuesta } = resp ?? {};
    const { status } = respuesta ?? {};
    return status;
  }

  const checkVin = async() => {
    const url = `${process.env.REACT_APP_PATH}virtual-inspection-status/get`;
    const headers = { "Content-Type": "application/json" };
    const method = "POST";
    const resp = await customRequest(url, headers, method, { folio });
    const { respuesta, renderMessage } = resp ?? {};
    const { status } = respuesta ?? {};
    if (status === Status.FAILED) goBack();
    if (status === Status.CANCELLED) {
      const { title, body } = renderMessage;
      let info = {
        icon: "fas fa-exclamation-triangle",
        iconColor: "#ED8B00",
        title,
        description: body,
        buttonText: "Aceptar",
        visible: true,
        onConfirm: () => {
          setModalAlert({ visible: false });
           window.location.reload();
        },
      };
      setModalAlert(info);
    }
    return status;
  }

  const onLoad = async () => {
    setReturnButton(false);

    !attemptCounter ? setAttemptCounter((prev) => prev + 1) : await setVin();
    
    if(isRecovering){
      await checkVin();
      setIsRecovering(false);
    }
    
    setCheckingVin(false);
  }

  useEffect(() => {
    onLoad();
  }, []);

  const generateToken = () => {
    const CryptoJS = require("crypto-js");
    const channelValues = JSON.parse(
      process.env.REACT_APP_CHANNEL_VALUES_DIRECT
    );
    const dataEncrypt = CryptoJS.AES.encrypt(
      JSON.stringify({
        cotizacionId: folio,
        oficinaId: channelValues && channelValues.oficina,
        ramoId: channelValues && channelValues.ramo,
        usuarioId: null,
        email: process.env.REACT_APP_DEFAULT_EMAIL,
      }),
      process.env.REACT_APP_RECOTIZADORES_KEY
    ).toString();

    const sign = require("jwt-encode");
    const secret = process.env.REACT_APP_RECOTIZADORES_KEY;
    const data = {
      origen: "externo",
      value: dataEncrypt,
    };
    const jwt = sign(data, secret);
    return jwt;
  };

  return (
    <>
      {checkingVin ? ( <Loading /> ) : ( 
        <div className="vehicle-inspection-container">
        {contextHolder}
        <p className="info">{info}</p>
        {done ? (
          <div className="done">
            <div className="badget green">
              <p>Fotos validadas</p>
            </div>
            <img src="https://images.prismic.io/portal-cotizacion-suramex/ZotAuh5LeNNTw4pt_fotos-validas.png?auto=format,compress"></img>
            <p className="ty">¡Gracias!</p>
            <p>
              Ya casi concluimos con la <br /> contratación
            </p>
          </div>
        ) : (
          <div className="steps">
            {arraySteps?.map((e, i) => (
              <div className="step" key={i}>
                {counting && i == 0 && (
                  <div className="waiting">
                    <p>Si en 2 minutos no recibes la liga, envíala nuevamente:</p>
                    <p>
                      <Countdown setCounting={setCounting} setSendingLink={setSendingLink} />
                    </p>
                  </div>
                )}
                <div className="img">
                  <img src={e.img}></img>
                </div>
                <div className="center">
                  <div className="row">
                    <p className="title">{e.label}</p>
                    {!e.btnImg && (
                      <div className="badget">
                        <p>Fotos por validar</p>
                      </div>
                    )}
                  </div>
                  <p className="desc">{e.info}</p>
                </div>
                <div className="btn">
                  {!e.btnImg ? (
                    <Button className="ant-btn-outline c-2 ant-btn-size-xs" onClick={verifyPhotos} loading={verifying}>
                      {e.btnText}
                    </Button>
                  ) : (
                    <>
                      {!sendingLink && !counting && (
                        <div
                          className="link"
                          onClick={() => {
                            const info = {
                              visible: true,
                              onConfirm: () => {
                                setModalSendLink({ visible: false });
                              },
                              onCancel: () => {
                                setModalSendLink({ visible: false });
                              },
                            };
                            setModalSendLink(info);
                          }}
                        >
                          <img src={e.btnImg}></img>
                          <p>{e.btnText}</p>
                        </div>
                      )}
                      {(sendingLink || counting) && (
                        <div className="link disabled">
                          <img src={e.btnImg}></img>
                          <p>{e.btnText}</p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        </div>
      )}
      <ModalSendLink info={modalSendLink} sendLink={sendLink} dataPreloaded={dataPreloaded} />
      <ModalAlert info={modalAlert} />
    </>
  );
}
